export const environment = {
  production: false,
  database: 'verify-enterprise',
  localeId: 'nl',
  functionRegion: 'europe-west1',
  useEmulators: false,
  sentryDsn:
    'https://249bc361ddd8d56348fe0daede6511e2@o4510992598695936.ingest.de.sentry.io/4510997698248784',
  sentryEnvironment: 'test',
  reCaptchaSiteKey: '6Lfk-zUtAAAAAN_J4T3uhUOZe_I8r-1IF8tJ53PJ',
  firebaseConfig: {
    apiKey: 'AIzaSyDSzN1mAJa5QcLo9K8dsUxNgmlD8ffcVg8',
    authDomain: 'fir-apps-test-741bb.firebaseapp.com',
    projectId: 'fir-apps-test-741bb',
    storageBucket: 'fir-apps-test-741bb.firebasestorage.app',
    messagingSenderId: '502071366977',
    appId: '1:502071366977:web:b9f974699bcdb42191fdc0',
    measurementId: 'G-BLS8DZQV9T',
  },
};
